<!-- 分享组件，pc发起端和pc观看端共用 -->
<template>
  <div class="vmp-share">
    <vh-dialog
      :title="isRehearsal ? $t('nav.nav_1054') : $t('nav.nav_1013')"
      :visible.sync="shareVisible"
      :close-on-click-modal="true"
      :modal-append-to-body="true"
      top="20vh"
      :width="dialogWidth"
    >
      <div class="vmp-share-wrap">
        <div class="vmp-share-wrap_imgs">
          <div class="img-item imgs_chat" @click="shareOtherDialog(1)">
            <span></span>
            <p>{{ $t('nav.nav_1016') }}</p>
          </div>
          <div class="img-item imgs_mp" v-if="canMiniprogramWatch" @click="shareOtherDialog(5)">
            <span></span>
            <p>{{ $t('nav.nav_1061') }}</p>
          </div>
          <div class="img-item imgs_qq" @click="shareOtherDialog(2)">
            <span></span>
            <p>{{ $t('nav.nav_1018') }}</p>
          </div>
          <div class="img-item imgs_weibo" @click="shareOtherDialog(3)">
            <span></span>
            <p>{{ $t('nav.nav_1017') }}</p>
          </div>

          <!-- 发起端不展示邀请海报分享按钮 -->
          <div class="img-item imgs_invite" v-if="canUseInviteCard" @click="shareOtherDialog(4)">
            <span></span>
            <p>{{ $t('nav.nav_1015') }}</p>
          </div>
        </div>
        <div class="vmp-share-wrap_input">
          <vh-input id="vmp-share-watch" v-model="watchWebUrl" class="input_width" readOnly>
            <vh-button slot="append" @click="copy">{{ $t('nav.nav_1014') }}</vh-button>
          </vh-input>
        </div>
        <div v-if="isRehearsal" class="share_tip">
          {{ $t('other.other_1021') }}
        </div>
      </div>
    </vh-dialog>
    <vh-dialog
      :title="$t('nav.nav_1013')"
      :visible.sync="shareOtherVisible"
      :close-on-click-modal="false"
      top="20vh"
      width="320px"
    >
      <div class="vmp-share_other" v-loading="!shareUrl">
        <vh-image :src="shareUrl">
          <div slot="error">
            <span v-if="shareUrl">{{ $t('host.k_541001') }}</span>
          </div>
          <div slot="placeholder">
            <span>{{ $t('host.k_541002') }}</span>
          </div>
        </vh-image>
      </div>
      <p class="vmp-share_introduce">
        {{ $t('nav.nav_1019') }}
        <br />
        {{ introduceText }}
      </p>
    </vh-dialog>
  </div>
</template>
<script>
  import { useRoomBaseServer, useInviteServer, useUserServer } from 'middle-domain';
  import { getUrl, doCopy } from '@/app-shared/utils/tool';
  import EmbedLinkMixin from '@/app-shared/mixins/embedLinkMixin';
  import { emitter, EMIT_DEFINE } from '@/app-shared/utils/emitter.js';
  import { fetchInviteCode } from '@/app-shared/utils/bizInvite.js';
  const DEP_TYPE_NUM = {
    webinar: 1, // 直播间
    page: 4, // 单场大会
    series: 5, // 系列会
    website: 6 // 聚合主站
  };
  export default {
    name: 'VmpShare',
    mixins: [EmbedLinkMixin],
    data() {
      return {
        shareVisible: false,
        shareOtherVisible: false,
        shareUrl: '',
        watchWebUrl: '',
        introduceText: this.$t('nav.nav_1022'),
        isInviteShare: false,
        isSubjectShare: false,
        isWatchInvite: false,
        embedMode: this.$route.query.embedMode || this.$route.query.embed_mode,
        businessSiteLink: '', // 全局嵌入链接
        businessShortDomain: '', // B租户短链服务域名
        sourceId: '',
        wxMiniProgramQrUrl: '' // 微信小程序二维码图片链接
      };
    },
    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
      this.inviteServer = useInviteServer();
      this.userServer = useUserServer();
    },
    created() {
      this.roomBaseState = this.roomBaseServer.state;
      // 观看端和发起端不一样
      const prefix = this.isWatch
        ? window.location.origin
        : `${window.location.protocol}${window.domainOfWatch()}`;

      this.watchWebUrl = `${prefix}${process.env.VUE_APP_ROUTER_BASE_URL}${
        this.isCms ? '/meeting' : ''
      }/lives/watch/${this.$route.params.id}`;

      if (window.location.href.indexOf('/special/detail') == -1) {
        this.getBusinessDomainConfigList();
      }
      this.initEvent();
    },
    computed: {
      dialogWidth() {
        return this.canMiniprogramWatch && this.canUseInviteCard ? '520px' : '440px';
      },
      // 是否观看端
      isWatch() {
        return !['send', 'record', 'clientEmbed'].includes(
          this.$domainStore.state.roomBaseServer.clientType
        );
      },
      isEmbed() {
        return this.$domainStore.state.roomBaseServer.embedObj.embed;
      },
      // 是否是彩排
      isRehearsal() {
        return this.$domainStore.state.roomBaseServer.watchInitData.live_type == 2;
      },
      // 是否是cms嵌入
      isCms() {
        return this.$domainStore.state.roomBaseServer.isCms == 1;
      },
      // 能否展示邀请卡分享
      canUseInviteCard() {
        return this.isInviteShare && this.isWatchInvite;
      },
      // 能否展示小程序观看： 非嵌入页 + 开通了权限
      canMiniprogramWatch() {
        return (
          !this.isEmbed &&
          !this.isWatch &&
          this.roomBaseState.permissionValueObj?.['miniprogram_watch'] == 1
        );
      }
    },
    methods: {
      // 事件驱动打开分享弹窗
      async openShareDialog(id) {
        if (this.embedMode == 1 && this.businessSiteLink) {
          // 全局嵌入链接分享
          this.sourceId = this.roomBaseState.watchInitData?.webinar?.id;
          const queryStr = encodeURIComponent(
            `embedMode=1&dep_id=${this.sourceId}&dep_type=${DEP_TYPE_NUM['webinar']}`
          );
          this.watchWebUrl = `${this.businessSiteLink}?dep_params=${queryStr}`;
        } else {
          // 观看端和发起端不一样
          const prefix = this.isWatch
            ? window.location.origin
            : `${window.location.protocol}${window.domainOfWatch()}`;
          this.watchWebUrl = `${prefix}${process.env.VUE_APP_ROUTER_BASE_URL}${
            this.isCms ? '/meeting' : ''
          }/lives/watch/${this.$route.params.id}`;

          if (id && this.isSubjectShare) {
            let languageTypeQueryStr = '';
            if (this.$route.query.languageType) {
              languageTypeQueryStr = `&languageType=${this.$route.query.languageType}`;
            }
            this.watchWebUrl = `${prefix}${process.env.VUE_APP_ROUTER_BASE_URL}/special/detail?id=${id}${languageTypeQueryStr}`;
          }
        }

        if (this.isRehearsal) {
          this.watchWebUrl = getUrl(this.watchWebUrl, { rehearsal: 1 });
        }
        this.shareVisible = true;
        // 是否展示邀请卡组件
        if (this.isInviteShare) {
          this.isWatchInvite = this.roomBaseState.inviteCard.status == '1';
          const shareId = `${this.roomBaseState.watchInitData.share_id}-0`;
          this.watchWebUrl = getUrl(this.watchWebUrl, { shareId: shareId });
        }
      },
      // 打开分享弹窗
      shareOtherDialog(index) {
        this.shareUrl = '';
        this.introduceText = '';
        if (index == 1) {
          this.openWeixinDialog();
          this.introduceText = this.$t('nav.nav_1022');
        } else if (index == 2) {
          this.openQqDialog();
        } else if (index == 3) {
          this.openWeiboDialog();
        } else if (index == 4) {
          this.openInviteDialog();
          this.introduceText = this.$t('nav.nav_1023');
        } else if (index == 5) {
          // 小程序
          this.openWxMiniProgramDialog();
          this.introduceText = this.$t('nav.nav_1062');
        }
        // 上报分享
        const shareChannelArr = [0, 3, 2, 1, 4, 5]; // 0:复制链接、1:微博、2:QQ、3:微信、4:邀请卡 5:微信小程序
        window.vhallReportForWatch?.report(170020, {
          share_channel: shareChannelArr[index]
        });
        window.VhallDataAgent.track('button_click_response', {
          button_type: 'share',
          share_channel: shareChannelArr[index]
        });
      },
      // 打开微信弹窗 - 3
      openWeixinDialog() {
        this.shareOtherVisible = true;
        const shareId = `${this.roomBaseState.watchInitData.share_id}-3`;
        let url = this.isSubjectShare
          ? this.watchWebUrl
          : getUrl(this.watchWebUrl, { shareId: shareId });
        this.shareUrl = `https://aliqr.e.vhall.com/qr.png?s=7&t=${encodeURIComponent(url)}`;
      },
      // 打开qq分享 - 2
      openQqDialog() {
        if (this.isSubjectShare) {
          let url = `//connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(
            this.watchWebUrl
          )}`;
          window.open(url, '_blank');
        } else {
          let urlStr = getUrl(this.watchWebUrl, {
            shareId: this.roomBaseState.watchInitData.share_id + '-2'
          });

          const p = {
            /* 获取URL，可加上来自分享到QQ标识，方便统计 */
            url: urlStr,
            desc: '',
            /* 分享标题(可选) */
            title: this.$t('nav.nav_1026'),
            /* 分享摘要(可选) */
            summary: this.$t('nav.nav_1025'),
            /* 分享图片(可选) */
            pics: '',
            /* 分享来源(可选) 如：QQ分享 */
            site: '',
            style: '201',
            width: 32,
            height: 32
          };
          const s = [];
          for (const i in p) {
            s.push(i + '=' + encodeURIComponent(p[i] || ''));
          }
          const url = 'http://connect.qq.com/widget/shareqq/index.html?' + s.join('&');
          window.open(url);
        }
      },
      // 打开微博 - 1
      openWeiboDialog() {
        if (this.isSubjectShare) {
          let url = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(
            this.watchWebUrl
          )}`;
          window.open(url, '_blank');
        } else {
          const shareId = `${this.roomBaseState.watchInitData.share_id}-1`;
          let url = getUrl(this.watchWebUrl, { shareId: shareId });
          const weiboShareUrl = `https://aliqr.e.vhall.com/qr.png?s=7&t=${url}`;
          const p = {
            url: weiboShareUrl,
            title: this.$t('nav.nav_1027')
          };
          const s = [];
          for (const i in p) {
            s.push(i + '=' + encodeURIComponent(p[i] || ''));
          }
          const weiBourl = 'http://service.weibo.com/share/share.php?' + s.join('&');
          window.open(weiBourl);
        }
      },
      // 打开邀请卡
      async openInviteDialog() {
        let inviteCode = this.inviteServer.state.invite_code;
        if (!inviteCode) {
          await fetchInviteCode(); // 获取邀请码
          inviteCode = this.inviteServer.state.invite_code || ''; // 再次赋值
        }
        if (!inviteCode) {
          this.$toast.fail(this.$t('common.common_1039'));
          return;
        }
        // 邀请卡分享二维码链接
        this.shareOtherVisible = true;
        let url;
        if (this.embedMode == 1 && this.businessSiteLink) {
          const queryStr = encodeURIComponent(
            `embedMode=1&dep_id=${this.sourceId}&dep_type=${
              DEP_TYPE_NUM['webinar']
            }&invite_code=${inviteCode}&invite_way=1${
              this.$route.query.channel || this.$route.query.refer
                ? '&channel=' + (this.$route.query.channel || this.$route.query.refer)
                : ''
            }`
          );
          url = `${this.businessSiteLink}?dep_params=${queryStr}`;
        } else {
          url = `${window.location.origin}${process.env.VUE_APP_ROUTER_BASE_URL}${
            this.isCms ? '/meeting' : ''
          }/lives/watch/${this.$route.params.id}?invite_code=${inviteCode}&invite_way=1${
            this.$route.query.channel || this.$route.query.refer
              ? '&channel=' + (this.$route.query.channel || this.$route.query.refer)
              : ''
          }`;
        }

        const shareId = `${this.roomBaseState.watchInitData.share_id}-1`;
        url = encodeURIComponent(getUrl(url, { shareId: shareId }));
        this.shareUrl = `https://aliqr.e.vhall.com/qr.png?s=7&t=${url}`;
      },
      // 打开微信小程序弹窗
      openWxMiniProgramDialog() {
        this.shareOtherVisible = true;
        if (this.wxMiniProgramQrUrl) {
          this.shareUrl = this.wxMiniProgramQrUrl;
        } else {
          // 接口请求获取小程序二维码
          const env_version = this.$route.query?.env_version;
          const params = {
            biz_id: process.env.VUE_APP_BIZ_ID || 2,
            biz_application_id: window.$hcl.app_id, //应用id
            business_uid: this.roomBaseState.watchInitData?.webinar.userinfo.user_id,
            page_path: 'pages/index/index',
            page_args: `wId=${this.$route.params.id}`, // 长度不超过32个字符
            env_version: ['trial', 'develop'].includes(env_version) ? env_version : 'release'
          };
          this.roomBaseServer
            .getWxMiniprogramQrImage(params)
            .then(res => {
              if (res && res.code == 200 && res.data && res.data.qr_image) {
                this.wxMiniProgramQrUrl = res.data.qr_image;
                this.shareUrl = this.wxMiniProgramQrUrl;
              } else {
                this.shareUrl = 'error';
              }
            })
            .catch(ex => {
              this.shareUrl = 'error';
            });
        }
      },
      // 复制地址
      copy() {
        // const input = document.getElementById('vmp-share-watch');
        // input.select();
        // document.execCommand('copy');
        doCopy(this.watchWebUrl);
        this.$message({
          message: this.$t('nav.nav_1024'),
          showClose: true,
          type: 'success',
          customClass: 'zdy-info-box'
        });
        // 上报分享
        window.vhallReportForWatch?.report(170020, {
          share_channel: 0
        });
        window.VhallDataAgent.track('button_click_response', {
          button_type: 'share',
          share_channel: 0
        });
      },
      initEvent() {
        emitter.on(EMIT_DEFINE.live_sidemenu_change, this.handleSidemenuChange);
      },
      handleSidemenuChange(option) {
        console.log('option:', option);
        if (option?.kind === 'share') {
          this.openShareDialog();
        }
      }
    },
    beforeDestroy() {
      emitter.off(EMIT_DEFINE.live_sidemenu_change, this.handleSidemenuChange);
    }
  };
</script>
<style lang="less">
  .vmp-share {
    &-wrap {
      &_imgs {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 0 18px 16px 18px;

        .img-item {
          text-align: center;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          span {
            display: block;
            width: 40px;
            height: 40px;
            cursor: pointer;
          }
          p {
            font-size: 14px;
            font-weight: 400;
            color: @font-light-normal;
            line-height: 20px;
            margin-top: 8px;
          }
        }
        .imgs_chat {
          span {
            background: url('./img/wechat@2x.png') 50% no-repeat;
            background-size: 100% 100%;
          }
          p:hover {
            color: #05c215;
          }
        }
        .imgs_mp {
          span {
            background: url('./img/wxmp@2x.png') 50% no-repeat;
            background-size: 100% 100%;
          }
          p:hover {
            color: #05c215;
          }
        }
        .imgs_qq {
          span {
            background: url('./img/qq@2x.png') 50% no-repeat;
            background-size: 100% 100%;
          }
          p:hover {
            color: #4a9afd;
          }
        }
        .imgs_weibo {
          span {
            background: url('./img/weibo@2x.png') 50% no-repeat;
            background-size: 100% 100%;
          }
          p:hover {
            color: #f8cf29;
          }
        }
        .imgs_invite {
          display: flex;
          flex-direction: column;
          align-items: center;
          span {
            background: url('./img/inv-card@2x.png') 50% no-repeat;
            background-size: 100% 100%;
          }
          p:hover {
            color: #fb3a32;
          }
        }
      }
      .share_tip {
        color: #666;
        font-size: 12px;
        margin-top: 8px;
      }
    }
    &_other {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 132px;
      padding-bottom: 20px;
      img {
        width: 132px;
        height: 132px;
      }
    }
    &_introduce {
      font-size: 14px;
      font-weight: 400;
      color: @font-light-low;
      line-height: 20px;
      text-align: center;
      word-break: break-word;
      // padding-bottom: 12px;
    }
  }
</style>
